import { render, staticRenderFns } from "./CaseFluidDetails.vue?vue&type=template&id=1c0758a8&scoped=true&"
import script from "./CaseFluidDetails.vue?vue&type=script&lang=js&"
export * from "./CaseFluidDetails.vue?vue&type=script&lang=js&"
import style0 from "./CaseFluidDetails.vue?vue&type=style&index=0&id=1c0758a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0758a8",
  null
  
)

export default component.exports